import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static outlets = ["configurator-state"];
  static values = { field: String };

  toggle(event) {
    if (!this.hasConfiguratorStateOutlet) return;
    if (this.fieldValue === "rounded_corner") {
      this.configuratorStateOutlet.roundedCornerToggled(event.target.checked);
    }
    // Other fields (white_frame, crop, mirror, label, etc.) are submitted
    // as checkbox values when the form is submitted — no orchestrator call needed.
  }
}
